module.exports = __webpack_public_path__ + "static/media/Modlin_Group_Traci_500.8ade844b.jpg";